import { NetworkRequest } from "api/actions";

export const getMonthEndStatus = (): NetworkRequest => {
    return {
        type: "NETWORK_REQUEST",
        method: "GET",
        url: "/api/maintenance/month-end"
    };
};
